<template>
  <div class="device-distribute-log">
    <app-query-bar
      :queryConfig="queryConfig"
      v-model="queryData"
      @onSearch="fetchLogs" />
    <app-export-bar
      @onExport="onExport"
      @onExportAll="onExportAll" />
    <app-data-table
      :columns="LOG_COLUMNS"
      :data="logs"
      v-model="queryData"
      @onPageConfigChange="fetchLogs">
      <template
        slot-scope="{ row }"
        slot="type">
        {{ BASIC_OPERATION_TYPE_TEXT[row.type] }}
      </template>
      <template
        slot-scope="{ row }"
        slot="optGroupType">
        {{ BASIC_OPERATOR_TYPE_TEXT[row.opt_group_type] }}
      </template>
    </app-data-table>
  </div>
</template>

<script>
import {
  LOG_COLUMNS,
  OPERATION_TYPE,
  BASIC_OPERATION_TYPE_TEXT,
  OPERATION_TYPE_OPTIONS,
  OPERATOR_TYPE,
  BASIC_OPERATOR_TYPE_TEXT,
  OPERATOR_TYPE_OPTIONS,
} from './constants';
import StoreBindLogApi from './store-bind-log.api';
import DataTransferUtil from '@/utils/data-transfer.util';

export default {
  name: 'device-distribute-log',
  data() {
    return {
      LOG_COLUMNS,
      BASIC_OPERATION_TYPE_TEXT,
      BASIC_OPERATOR_TYPE_TEXT,
      queryConfig: [
        {
          fieldName: 'type',
          name: '操作类型',
          type: 'select',
          options: OPERATION_TYPE_OPTIONS,
        },
        {
          fieldName: 'optGroupType',
          name: '操作人类型',
          type: 'select',
          options: OPERATOR_TYPE_OPTIONS,
        },
        {
          fieldName: 'optNickName',
          name: '操作人',
        },
        {
          fieldName: 'storeName',
          name: '关联门店',
        },
        {
          fieldName: 'commonStoreName',
          name: '被关联门店',
        },
      ],
      queryData: {
        page: 1,
        limit: 10,
        count: 0,
        type: OPERATION_TYPE.ALL,
        optGroupType: OPERATOR_TYPE.ALL,
        optNickName: '',
        storeName: '',
        commonStoreName: '',
      },
      logs: [],
    };
  },
  created() {
    this.fetchLogs();
  },
  methods: {
    async fetchLogs() {
      const {
        page,
        limit,
        type,
        optGroupType,
        optNickName,
        storeName,
        commonStoreName,
      } = this.queryData;
      const {
        count = 0,
        results = [],
      } = await StoreBindLogApi.getLogs(
        page,
        limit,
        type,
        optGroupType,
        optNickName,
        storeName,
        commonStoreName,
      );
      this.logs = results;
      this.$set(this.queryData, 'count', count);
    },
    async onExport() {
      const key = await StoreBindLogApi.export(this.queryData);
      await DataTransferUtil.downloadFileBySecretKey(key);
    },
    async  onExportAll() {
      const key = await StoreBindLogApi.export();
      await DataTransferUtil.downloadFileBySecretKey(key);
    },
  },
};
</script>

<style scoped>

</style>
